import {
  accountGet,
  accountPost,
  accountDelete
} from './prefixedUrls.js';

import * as Types from './addressbook.service.js';

/**
 * @typedef {Object} Contact
 * @property {number} id
 * @property {string} name
 * @property {string} surname
 * @property {string} email
 * @property {string} company
 * @property {Types.Addressbook[]} addressbooks
 */

/**
 * Get all contacts for a specific account
 * @param {string} accountId The account uuid
 * @returns {Promise<Contact[]>}
 */
export async function getAll(accountId) {
  let res = await accountGet('contacts', accountId);
  return res.data;
}

/**
 * Get a contact by its id (and account id)
 * @param {string} accountId The account uuid
 * @param {string} id The contact id
 * @returns {Promise<Contact>}
 */
export async function get(accountId, id) {
  let res = await accountGet(`contacts/${id}`, accountId);
  return res.data;
}

/**
 * Remove a contact
 * @param {string} accountId The account uuid
 * @param {number} id
 */
export async function remove(accountId, id) {
  await accountDelete(`contacts/${id}`, accountId);
}
